"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticGroupsLoader = void 0;
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const StaticFieldOptionsGetterRegistry_1 = __importDefault(require("@opsbase/lib-data-staticfieldoptions/StaticFieldOptionsGetterRegistry"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const react_1 = require("react");
const useDataTree_1 = __importDefault(require("../../useDataTree"));
const useDataTreeActions_1 = __importDefault(require("../../useDataTreeActions"));
function StaticGroupsLoader(props) {
    const { groupBy } = props;
    const dt = (0, useDataTree_1.default)();
    const { filters } = (0, useView_1.default)(dt.viewId);
    const { setGroupCollectionForGroupBy } = (0, useDataTreeActions_1.default)();
    const self = (0, useSelf_1.default)();
    (0, react_1.useEffect)(() => {
        const queryField = QueryFieldRegistry_1.default[groupBy.queryFieldKey];
        const pertinentFilters = filters === null || filters === void 0 ? void 0 : filters.filter(f => f.queryFieldKey === groupBy.queryFieldKey);
        const options = StaticFieldOptionsGetterRegistry_1.default[queryField.fieldType](self);
        const groups = options
            .map(({ id, title, color }) => (Object.assign(Object.assign({}, groupBy), { id, title, color })))
            .filter(g => !(pertinentFilters === null || pertinentFilters === void 0 ? void 0 : pertinentFilters.length) || (pertinentFilters === null || pertinentFilters === void 0 ? void 0 : pertinentFilters.find(f => f.id === g.id)));
        setGroupCollectionForGroupBy(groupBy, {
            loading: false,
            lastLoaded: new Date(),
            totalCount: groups.length,
            groups,
        });
    }, [filters, groupBy, self, setGroupCollectionForGroupBy]);
    return null;
}
exports.StaticGroupsLoader = StaticGroupsLoader;
exports.default = StaticGroupsLoader;
